import { Component } from "react";
import GetAppOutlinedIcon from "@material-ui/icons/GetAppOutlined";
import { connect } from "react-redux";
import { addSettings } from "../../../actions";
import {
  signedAgreements,
  getUnarchivedAgreemetns,
} from "./../../../config/client_api_calls";
import $ from "jquery";
import DataTable from "../../../components/Tables/DataTable";
import { tableLoader } from "../../../components/ContentLoaders/table_loader";
import MsaWarning from "../ExtraComponents/MsaWarning";
import SettingsError from "../ExtraComponents/SettingsError";
import PageTitle from "../ExtraComponents/PageTitle";
import HelperClass from "./../../../config/helperClass";
import { PDFDownloadLink, Document, Page } from "@react-pdf/renderer";
import {
  THEME_TEXT_COLOR,
  THEME_COLOR,
  APP_LIVE_URL,
} from "./../../../config/config";
import dateFormat, { masks } from "dateformat";
import UnsignedAgreements from "./unsignedagreements";
const auth = new HelperClass();

class Agreements extends Component {
  constructor() {
    super();
    this.state = {
      tableData: [],
      tableDataUnarchived: [],
      errorMessage: "",
      successMessage: "",
      tableLoader: true,
      pdfurl: "",
      activeTab: "signed",
      unsigned_agreements: "1",
      columnServices: [
        { name: "Agreement" },
        { name: "Signee Name" },
        { name: "Signee Title" },
        { name: "Signee Email" },
        {
          name: "Date Signed",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{auth.formatDate(value)}</div>;
            },
          },
        },
        {
          name: "Status",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.signedText(value, tableMeta)}</div>;
            },
          },
        },
        {
          name: "Approved",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.approvedText(value, tableMeta)}</div>;
            },
          },
        },
        {
          name: "Mandatory",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.mandatoryText(value, tableMeta)}</div>;
            },
          },
        },
        {
          name: "View",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.viewPdf(value, tableMeta)}</div>;
            },
          },
        },
      ],
      columnServicesUnarchived: [
        { name: "Agreement Title" },
        {
          name: "Remove Date",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.format_date(value)}</div>;
            },
          },
        },
        {
          name: "Signed",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.signedText(value, tableMeta)}</div>;
            },
          },
        },
        {
          name: "Date Signed",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.format_date(value)}</div>;
            },
          },
        },
        { name: "Reason" },
        {
          name: "View",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.viewPdf(value, tableMeta)}</div>;
            },
          },
        },
      ],
    };
  }

  signedText = (value, tableMeta) => {
    //console.log("tableMeta.rowData: ", tableMeta.rowData[9]);
    let is_default = value;
    if (is_default === "Yes") {
      return (
        <span className="badge badge-outline-secondary">
          <em className="icon ni ni-done"></em> Signed
        </span>
      );
    } else {
      return (
        <span className="badge badge-outline-danger">
          <em className="icon ni ni-na"></em> Pending
        </span>
      );
    }
  };

  approvedText = (value, tableMeta) => {
    //console.log("tableMeta.rowData: ", tableMeta.rowData[9]);
    let is_default = value;
    if (is_default === "Yes") {
      return (
        <span className="badge badge-outline-secondary">
          <em className="icon ni ni-done"></em> Yes
        </span>
      );
    } else {
      return (
        <span className="badge badge-outline-danger">
          <em className="icon ni ni-na"></em> No
        </span>
      );
    }
  };

  viewPdf = (value, tableMeta) => {
    let domain_str = value;
    const rowIndex = tableMeta.rowIndex;
    const agreement_title = tableMeta.rowIndex;
    //console.log("viewPdf pdf_str: ", domain_str);
    if (domain_str && domain_str !== "") {
      return (
        <div>
          {this.state.downloadingIndex === rowIndex ? (
            <div className="text-left">
              <div
                className="spinner-border spinner-border-sm text-primary"
                role="status"
              >
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          ) : (
            <a
              onClick={() => {
                this.setState({ downloadingIndex: rowIndex });
                setTimeout(() => {
                  //this.setState({ downloadingIndex: null });
                  this.downloadPdf(value, tableMeta);
                }, 2000);
                //this.downloadPdf(value, tableMeta)
              }}
              style={{ cursor: "pointer" }}
              title="Download PDF"
            >
              <span className="badge badge-outline-primary">
                <em
                  className="icon ni ni-download"
                  style={{ fontSize: "18px" }}
                ></em>
              </span>
            </a>
          )}
        </div>
      );
    } else {
      return (
        <div>
          <span className="badge badge-outline-primary">---</span>
        </div>
      );
    }
  };

  format_date = (value, tableMeta) => {
    let date = value;
    return dateFormat(date, "mm-dd-yyyy");
  };

  mandatoryText = (value, tableMeta) => {
    let is_default = value;
    if (is_default === "No") {
      return (
        <span className="badge badge-outline-warning">
          <em className="icon ni ni-na"></em> No
        </span>
      );
    } else {
      return (
        <span className="badge badge-outline-secondary">
          <em className="icon ni ni-done"></em> Yes
        </span>
      );
    }
  };

  viewDownloadBtns = (tableMeta) => {
    return (
      <div>
        <a
          onClick={() =>
            this.addMenuHistory(
              "/" +
                auth.getResellerIdentifier() +
                "/client/agreements/pdfdownload/" +
                btoa(tableMeta.rowData[0] + "###" + tableMeta.rowData[8])
            )
          }
          disabled={tableMeta.rowData[5] === "No" ? true : false}
          target="_blank"
          style={{ cursor: "pointer", color: "#006393" }}
        >
          <span className="badge badge-outline-primary">
            <em
              className="icon ni ni-download"
              style={{ fontSize: "18px" }}
            ></em>
          </span>
        </a>{" "}
      </div>
    );
  };

  async componentDidMount() {
    const servicesResponce = await signedAgreements(
      auth.getClientAccount(),
      auth.getClientToken()
    );
    //console.log("servicesResponce.data: ", servicesResponce.data);
    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      this.setState({
        tableData: [],
        tableLoader: false,
      });
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        tableData: servicesResponce.data.data,
        tableLoader: false,
      });
    } else {
      this.setState({
        tableData: [],
        tableLoader: false,
      });
      //window.location.replace("/error");
    }
  }

  getUnarchivedAgreemetns = async () => {
    this.setState({ tableLoader: true });
    const servicesResponce = await getUnarchivedAgreemetns(
      auth.getClientAccount(),
      auth.getClientToken()
    );
    // console.log("getUnarchivedAgreemetns: ", servicesResponce.data);
    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      this.setState({
        tableDataUnarchived: [],
        tableLoader: false,
      });
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        tableDataUnarchived: servicesResponce.data.data,
        tableLoader: false,
      });
    } else {
      this.setState({
        tableDataUnarchived: [],
        tableLoader: false,
      });
      //window.location.replace("/error");
    }
  };

  addMenuHistory = (link) => {
    this.props.props.history.push(link);
  };

  setMarkUp = (value, tableMeta) => {
    let pdf_path = tableMeta.rowData[2];
    // console.log("pdf_path: ", pdf_path);
    if (tableMeta.rowData[1] === "Yes") {
      this.setState({
        pdfurl:
          process.env.REACT_APP_API_URL + "public/msa_agreements/" + pdf_path,
      });
    } else {
      this.setState({
        pdfurl: "",
      });
    }
    // console.log(this.state.pdfurl);
    return this.state.pdfurl;
  };

  modalHide = () => {
    window.$("#modalForm").modal("hide");
  };

  showModal = () => {
    window.$("#modalForm").modal("show");
  };

  downloadPdf = async (d_f_name, tableMeta) => {
    var url = d_f_name;
    const accountCode = auth.getClientAccount();
    const companyName = auth.getCompNameClient();
    const agreementTitle = tableMeta.rowData[0] || "Agreement";
    let file_name = this.generateFileName(accountCode, companyName, agreementTitle);
    let check_url = this.isStringURL(url);
    // console.log("check_url: " + check_url + " " + url);

    url = APP_LIVE_URL + "files_data/agreements/" + url;

    fetch(url)
      .then((x) => x.blob())
      .then((b) => {
        // console.log("B INSTANCE", b instanceof Blob);
        const url = window.URL.createObjectURL(b);
        var a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";
        a.href = url;
        a.download = file_name;
        a.click();
        window.URL.revokeObjectURL(url);
        this.setState({ errorMessage: "", downloadingIndex: null });
      })
      .catch((error) => {
        this.setState({
          errorMessage: "There is some error while downloading the attachment.",
          downloadingIndex: null,
        });
        setTimeout(() => {
          this.setState({ errorMessage: "" });
        }, 4000);
        // Handle any errors that occurred during the fetch
        console.error("Fetch error:", error);
      });
  };

  generateFileName = (accountCode, companyName, agreementTitle) => {
    // Handle falsy values - provide defaults
    const safeAccountCode = accountCode;
    const safeCompanyName = companyName;
    const safeAgreementTitle = agreementTitle || "Agreement";
    
    // Sanitize all parts: remove special characters and replace spaces with underscores
    const sanitizedAgreementTitle = safeAgreementTitle
      .replace(/[^a-zA-Z0-9 ]/g, "")
      .replace(/\s+/g, "_");
    const sanitizedCompanyName = safeCompanyName
      .replace(/[^a-zA-Z0-9 ]/g, "")
      .replace(/\s+/g, "_");
    
    return `${sanitizedAgreementTitle}_${safeAccountCode}_${sanitizedCompanyName}.pdf`;
  };

  processString = (input) => {
    // Remove special characters and replace spaces with hyphens
    const processed = input
      .replace(/[^a-zA-Z0-9 ]/g, "") // Remove special characters
      .replace(/\s+/g, "-") // Replace spaces with hyphens
      .toLowerCase(); // Optional: Convert to lowercase
    return processed;
  };

  isStringURL = (str) => {
    try {
      new URL(str);
      return true;
    } catch (error) {
      return false;
    }
  };

  render() {
    return (
      <div className="nk-content " id="Services_Block">
        <div className="container-fluid">
          {this.props.defaultSettings === "missing" ? <SettingsError /> : null}
          {/* MSA WARNING  START*/}
          {this.props.is_msa_signed === "No" ? <MsaWarning /> : null}

          {/* MSA WARNING END */}

          <div className="nk-content-inner">
            <div className="nk-content-body">
              {/* PAGE TITLE START */}
              <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                  <div className="nk-block-head-content">
                    <h3 className="nk-block-title page-title">
                      <PageTitle
                        name={
                          this.state.activeTab === "signed"
                            ? "Signed Agreements"
                            : this.state.activeTab === "unsigned"
                            ? "Unsigned Agreements"
                            : "Archived Agreements"
                        }
                        icon="icon ni ni-reports-alt"
                      />
                    </h3>
                  </div>
                </div>
              </div>
              {/* PAGE TITLE END */}
              <div className="nk-block">
                <ul className="nav nav-tabs">
                  <li className="nav-item">
                    <a
                      className={`nav-link ${
                        this.state.activeTab === "signed" ? "active" : ""
                      }`}
                      data-toggle="tab"
                      href="#tabItem1"
                      onClick={() => this.setState({ activeTab: "signed" })}
                    >
                      Signed
                    </a>
                  </li>  
                  <li className="nav-item">
                    <a
                      className={`nav-link ${
                        this.state.activeTab === "unsigned" ? "active" : ""
                      }`}
                      data-toggle="tab"
                      href="#tabItem2"
                      onClick={() => this.setState({ activeTab: "unsigned" })}
                    >
                      Unsigned
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className={`nav-link ${
                        this.state.activeTab === "archived" ? "active" : ""
                      }`}
                      data-toggle="tab"
                      href="#tabItem3"
                      onClick={() => {
                        this.setState({ activeTab: "archived" });
                        this.getUnarchivedAgreemetns();
                      }}
                    >
                      Archived
                    </a>
                  </li>
                </ul>
                {/* Table 5th Col Start */}
                <div className="tab-content">
                  {this.state.activeTab === "signed" && (
                    <div className="tab-pane active" id="tabItem1">
                      <div className="row g-gs">
                        <div className="col-xxl-12">
                          <div className="nk-block nk-block-lg">
                            {this.state.errorMessage !== "" ? (
                              <div
                                className="example-alert example-alert-revoke mt-3 mb-3"
                                style={{ marginBottom: "15px" }}
                              >
                                <div className="alert alert-pro alert-danger">
                                  <div className="alert-text">
                                    <h4>Error</h4>
                                    <p>{this.state.errorMessage}</p>
                                  </div>
                                </div>
                              </div>
                            ) : null}
                            {/* START DATATABLE */}
                            {this.state.tableLoader === true ? (
                              tableLoader()
                            ) : (
                              <DataTable
                                columns={this.state.columnServices}
                                tableData={this.state.tableData}
                                title="Signed Agreements"
                              />
                            )}

                            {/* END TABLE */}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {this.state.activeTab === "unsigned" && (
                    <div className="tab-pane active" id="tabItem2">
                      <div className="row g-gs">
                        <div className="col-xxl-12">
                          <div className="nk-block nk-block-lg">
                            <UnsignedAgreements
                              props={{ ...this.props, match: { params: {} } }}
                              switchToSignedTab={() => this.setState({ activeTab: "signed" })}
                              key="unsigned-agreements"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {this.state.activeTab === "archived" && (
                    <div className="tab-pane active" id="tabItem3">
                      <div className="row g-gs">
                        <div className="col-xxl-12">
                          <div className="nk-block nk-block-lg">
                            {this.state.errorMessage !== "" ? (
                              <div
                                className="example-alert example-alert-revoke mt-3 mb-3"
                                style={{ marginBottom: "15px" }}
                              >
                                <div className="alert alert-pro alert-danger">
                                  <div className="alert-text">
                                    <h4>Error</h4>
                                    <p>{this.state.errorMessage}</p>
                                  </div>
                                </div>
                              </div>
                            ) : null}
                            {/* START DATATABLE */}
                            {this.state.tableLoader === true ? (
                              tableLoader()
                            ) : (
                              <DataTable
                                columns={this.state.columnServicesUnarchived}
                                tableData={this.state.tableDataUnarchived}
                                title="Archived Agreements"
                              />
                            )}

                            {/* END TABLE */}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    defaultSettings: state.settings,
    is_msa_signed: state.is_msa_signed,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    addSettings: (payload) => dispatch(addSettings(payload)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Agreements);
